import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { firebaseAuth } from '@/config/firebase';

export const firebaseService = {
	async signIn(email: string, password: string) {
		const credential = await signInWithEmailAndPassword(
			firebaseAuth,
			email,
			password
		);

		const user = credential.user;
		const token = await user.getIdToken();

		return { user, token };
	},

	async logout() {
		await signOut(firebaseAuth);
	},
};
